<template>
    <div>
          <div v-if="unreadNotifications.length > 0" class="pb-2">
            <div class="py-2 px-4" :style="(notificationIndex > 0?'border-top:1px solid #ffffff;':'')" :class="'bg-severity-'+notification.severity" v-for="(notification, notificationIndex) in unreadNotifications" :key="notification.id">
              <div class="d-flex">{{ $moment(notification.createdAt).format('DD/MM/YYYY HH:mm') }}<v-chip color="transparent" @click="setAsRead(notification);" x-small class="ml-auto">Markeren als gelezen</v-chip></div>
              <div class="d-flex align-items-center pb-1">
              <div>{{notification.name}}</div>
              </div>
              <div class="d-flex flex-wrap">
              <v-chip :to="moduleInfo.route?{name:moduleInfo.route, params:{id: notification[moduleInfo.item].id }}:null" outlined class="mr-2 mt-1" small v-for="moduleInfo in Notification.LINKED_MODULES.filter(linked => notification[linked.item]?.name)" :key="notificationIndex+'_'+moduleInfo.item"><v-icon x-small left>{{ moduleInfo.icon }}</v-icon>{{ notification[moduleInfo.item].name }}</v-chip>
              </div>
            </div>
          </div>
        <div class="px-4 py-1" v-else>
            <v-alert dense text type="info">Geen ongelezen meldingen!</v-alert>
        </div>
        </div>
</template>
<script>
import Notification from './../models/notification';

export default {
    name: 'eod-notifications',
    props: {
        value: Boolean
    },
    mounted(){
        this.getDataFromApi();
    },
    data: () => ({
        unreadNotifications: [],
        Notification: Notification,
        settings: require('./../classes/settings.js')
    }),
    methods: {
        setAsRead(notification){
            this.$eod.save('Notification', {
                id: notification.id,
                isRead: true
            }).then(response => {
                if(response?.data?.data?.updateNotification?.id){
                    this.getDataFromApi();
                    this.$emit('update');
                }
            })
        },
        getDataFromApi(){
            this.$eod.get('notifications', ['id','name','description', 'createdAt', 'severity', 'project{id name}', 'task{id name}', 'company{id name}', 'user{id}'], {
                where: [
                {
                    column: 'isRead',
                    value: '0'
                }
                ]
            }).then(response => {
                if(response?.data?.data?.notifications?.edges){
                    this.unreadNotifications = response.data.data.notifications.edges.map(item => new Notification(item));
                }
            });
        }
    }
}
</script>